import { ResourceTable } from '@medplum/react'
import { invariant } from '@seen/core/invariant'
import * as appointments from '@seen/core/models/appointments/index'
import { useMemo } from 'react'
import { useParams } from 'react-router'
import { CancelAppointmentButton } from '#src/components/appointment/CancelAppointmentButton.tsx'
import { Loader } from '#src/components/core/Loader.tsx'
import { PageLayout } from '#src/components/display/PageLayout.tsx'
import { useFhirRead } from '#src/hooks/useFhirRead.ts'

export function AppointmentDisplayPage(): React.ReactNode {
  const { appointmentId } = useParams<{ appointmentId: string }>()
  invariant(appointmentId, 'appointmentId is required')

  const appointmentQuery = useFhirRead('Appointment', appointmentId)
  const appointment = useMemo(
    () =>
      appointmentQuery.data &&
      appointments.ExtendedAppointment.fromFhirResource(appointmentQuery.data),
    [appointmentQuery.data]
  )
  if (appointmentQuery.isLoading) {
    return <Loader />
  }
  if (!appointment) {
    return null
  }

  return (
    <PageLayout title={`Appointment: ${appointment.title}`}>
      <ResourceTable ignoreMissingValues value={appointment.toFhirResource()} />
      <CancelAppointmentButton appointment={appointment} />
    </PageLayout>
  )
}
